import React, { useEffect, useState, useReducer, useContext, useRef } from "react";
import { useForm } from 'react-hook-form';
import { useHistory } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import api from '../../services/api';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import Swal from "sweetalert2";
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalProjetoInterno = ({
    isDesktop,
    peritosList,
    isOpen,
    formData,
    onGetPerito,
    setIsOpen
}) => {
    var [searchTimesheetItens, setSearchTimesheetItens] = useState([]);
    const [searchTimesheetString, setSearchTimesheetString] = useState("");
    const [buttonTimeSheetShow, setButtonTimeSheetShow] = React.useState(true);
    const [timeSheetShow, setTimeSheetShow] = React.useState(false);
    var [searchTimesheetItem, setSearchTimesheetItem] = useState([]);

    useEffect(() => {
        if (!isOpen) {
            setSearchTimesheetItem(null);
            setSearchTimesheetItens([]);
            setSearchTimesheetString("");
            setButtonTimeSheetShow(true);
            setTimeSheetShow(false);
        }
    }, [isOpen]);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const searchStyling = {
        borderRadius: "10px",
        boxShadow: "none",
        "background-color": "white",
        width: "100%"
    };

    const history = useHistory();
    const { register } = useForm();

    const timesheetSearch = async (value) => {
        let result = null;
        try {
            const response = await api.get(`Timesheet/search?search=${value}&length=10&ProjetoInterno=true`);
            result = response.data;
            return result;
        } catch (err) {
            return result;
        }
    }

    const timesheetPost = async (values) => {
        
        let result = null;
        let payload = {
            idProjetoInterno: values.idProjetoInterno
        }
        try {
            const response = await api.post(`Timesheet`, payload);
            result = response.data;
            return result;
        } catch (err) {
            return result;
        }
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const afterOpenModal = () => { };

    const formTimesheet = async () => {
        let payload = searchTimesheetItem;
        const timeSheetResult = await timesheetPost(payload);
        formData(null, 1, 10);
        history.push(`/timesheetpidetalhespage/#${timeSheetResult.data.idTimesheet}`);
    };

    const redirectTimesheetDetalhes = async () => {
        history.push(`/timesheetpidetalhespage/#${searchTimesheetItem.idTimesheet}`);
    };

    const handleOnSearchTimesheet = async (search, results) => {
        if (search.length > 2) {
            const timesheetResult = await timesheetSearch(`${search}`);
            if (!!timesheetResult) {
                searchTimesheetItens = []
                timesheetResult.data.map((item, index) => {
                    searchTimesheetItens.push({
                        id: item.id,
                        idTimesheet: item.idTimesheet,
                        idProjetoInterno: item.idProjetoInterno,
                        numeroTimesheet: item.numeroTimesheet,
                        disciplina: item.disciplina,
                        clienteNome: item.clienteNome,
                        seguradoNome: item.seguradoNome,
                        periciaLider: item.periciaLider,
                        idPericia: item.idPericia,
                        idRegulacao: item.idRegulacao,
                        sigla: item.sigla,
                        name: item.sigla + ' - ' + item.disciplina
                    });
                });
                setSearchTimesheetItens(searchTimesheetItens);
                setSearchTimesheetString(search);
            }
        }
    }

    const handleOnSelectTimesheet = (item) => {
        searchTimesheetItem = item;
        if (searchTimesheetItem.idTimesheet == null) {
            setButtonTimeSheetShow(true);
        }
        else {
            setButtonTimeSheetShow(false);
        }

        if (item != null) {
            setTimeSheetShow(true);
        }
        else {
            setTimeSheetShow(false);
        }

        setSearchTimesheetItem(searchTimesheetItem);
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Cadastro realizado com sucesso",
            icon: "success",
            // customClass: {
            //     confirmButton: 'default-button-alert'
            //   },
            confirmButtonText: "OK",
        });
    };

    const registrationFailure = () => {
        Swal.fire({
            title: "Atenção",
            text: "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.",
            icon: "error",
            // customClass: {
            //     confirmButton: 'default-button-alert'
            //   },
            confirmButtonText: "OK",
        });
    };

    const registrationInformation = () => {
        Swal.fire({
            title: "Informação",
            text: "Preencha todos os campos necessários",
            icon: "info",
            // customClass: {
            //     confirmButton: 'default-button-alert'
            //   },
            confirmButtonText: "OK",
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <Tabs>
                <StyledForm>
                    <p className="modal-close" onClick={closeModal}>X</p>
                </StyledForm>
                <TabList>
                    <StyledForm>
                        <Tab>Timesheet</Tab>
                    </StyledForm>
                </TabList>
                <TabPanel>
                    <StyledForm>
                        <div className="position-relative form-group">
                            <p className="modal-title">Lançamento de Timesheet</p>
                            <div className="position-relative form-group modal-width">
                                <ReactSearchAutocomplete
                                    items={searchTimesheetItens}
                                    onSearch={handleOnSearchTimesheet}
                                    onHover={handleOnSearchTimesheet}
                                    onSelect={handleOnSelectTimesheet}
                                    onFocus={handleOnSearchTimesheet}
                                    inputSearchString={searchTimesheetString}
                                    styling={searchStyling}
                                />

                            </div>
                            {
                                timeSheetShow ?
                                    <div>
                                        <p className="modal-info">Nº do Timesheet</p>
                                        <p className="modal-info-data"> {searchTimesheetItem.numeroTimesheet} </p>
                                        <p className="modal-info">Sigla </p>
                                        <p className="modal-info-data">{searchTimesheetItem.sigla}  </p>
                                        <p className="modal-info">Titulo </p>
                                        <p className="modal-info-data">{searchTimesheetItem.disciplina}  </p>
                                        {/* <p className="modal-info">Lider </p>
                                        <p className="modal-info-data">{searchTimesheetItem.periciaLider}  </p>
                                        <p className="modal-info">Cliente </p>
                                        <p className="modal-info-data">{searchTimesheetItem.clienteNome} </p>
                                        <p className="modal-info">Segurado </p>
                                        <p className="modal-info-data">{searchTimesheetItem.seguradoNome}  </p> */}
                                    </div>
                                    :
                                    <div></div>
                            }
                        </div>
                        <div className="position-relative form-group modal-align-center">
                            {
                                timeSheetShow ?
                                    buttonTimeSheetShow ?
                                        <input className='default-button-red' value='Adicionar' type="button" onClick={formTimesheet} />
                                        :
                                        <input className='default-button-red' value='Acessar' type="button" onClick={redirectTimesheetDetalhes} />
                                    : null
                            }
                        </div>
                    </StyledForm>
                </TabPanel>
            </Tabs>
        </Modal>);
};
